import(/* webpackMode: "eager" */ "E:\\Final Projects Repo\\LocoBuzzWebsite\\locobuzz-website\\app\\platform\\location-intelligence\\page.js");
